export default __webpack_public_path__ + "static/media/ic_github-1.91a3ce5c.svg";